// Mock data for Glow & You landing page

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      about: 'À propos',
      contact: 'Contact',
      testimonials: 'Témoignages'
    },
    hero: {
      title: 'Révèle Ta Meilleure Version',
      subtitle: 'Un accompagnement personnalisé pour révéler et harmoniser ton style, ta personnalité et ta garde-robe',
      cta: 'Commencer mon accompagnement'
    },
    aboutSection: {
      title: 'À propos de Glow & You',
      text: 'Glow and You est spécialisé en consultation en image et offre un accompagnement personnalisé visant à révéler et harmoniser le style, la personnalité et la garde-robe de chaque personne. À travers une approche douce, respectueuse et profondément authentique, Glow and You guide chacun·e vers une image alignée avec sa véritable identité. L\'objectif : révéler la meilleure version de soi, en toute confiance.'
    },
    servicesSection: {
      title: 'Ce que nous offrons',
      subtitle: 'Des services sur mesure pour révéler votre identité visuelle authentique, sublimer votre présence et faire de chaque tenue une expression de qui vous êtes vraiment.',
      services: [
        {
          id: 1,
          title: '1. Signature Style',
          subtitle: 'Comprendre ton style et ton image',
          description: 'Un accompagnement pour mieux te connaître et définir un style qui te ressemble vraiment.',
          subServices: ['Analyse de style', 'Étude de morphologie', 'Colorimétrie'],
          image: 'https://images.unsplash.com/photo-1551232864-3f0890e580d9'
        },
        {
          id: 2,
          title: '2. Dressing Intelligent',
          subtitle: 'Optimiser ta garde-robe',
          description: 'Apprendre à utiliser ce que tu possèdes déjà et construire une garde-robe cohérente et efficace.',
          subServices: ['Tri de dressing', 'Garde-robe capsule', 'Audit de garde-robe', 'Conseils d\'achat'],
          image: 'https://images.unsplash.com/photo-1547822280-d923f07fffbd'
        },
        {
          id: 3,
          title: '3. Accompagnement Personnalisé',
          subtitle: 'Trouver les bonnes pièces pour toi',
          description: 'Un accompagnement sur mesure pour créer des looks adaptés à ton style, ta vie et tes besoins.',
          subServices: ['Magasinage accompagné', 'Tenues pour événements', 'Relooking complet', 'Conseil en image spécial mariée (choix de robe)'],
          image: 'https://images.unsplash.com/photo-1769345330795-322d300e386c'
        },
        {
          id: 4,
          title: '4. Ateliers & Formations',
          subtitle: 'Devenir autonome dans ton style',
          description: 'Des ateliers pour t\'apprendre à comprendre ton image et faire les bons choix par toi-même.',
          subServices: ['Atelier individuel', 'Atelier de groupe'],
          image: 'https://images.unsplash.com/photo-1761250246894-ee2314939662'
        }
      ]
    },
    forWhomSection: {
      title: 'Pour qui ?',
      subtitle: 'Ce service est pour toi si :',
      points: [
        'Tu veux te sentir plus confiante dans ton image',
        'Tu ne sais pas comment t\'habiller selon ta morphologie',
        'Tu veux arrêter d\'acheter sans porter tes vêtements',
        'Tu veux un style clair, simple et aligné'
      ]
    },
    bookingSection: {
      title: 'Comment réserver?',
      description: 'Afin d\'offrir un service personnalisé, cohérent et parfaitement adapté à chaque personne, Glow & You fonctionne selon un processus simple et structuré, en trois étapes.',
      steps: [
        {
          number: '1',
          title: 'Remplir le formulaire',
          description: 'Complète notre formulaire de pré-consultation pour nous faire connaître tes besoins'
        },
        {
          number: '2',
          title: 'Analyse par Glow & You',
          description: 'Notre équipe analyse ta demande et identifie les services adaptés à ton profil'
        },
        {
          number: '3',
          title: 'Envoi d\'un lien de réservation',
          description: 'Tu reçois un lien personnalisé pour réserver ton accompagnement'
        }
      ],
      cta: 'Prêt·e à révéler la meilleure version de toi ?',
      ctaSubtitle: 'Remplis le formulaire pour commencer ton accompagnement personnalisé'
    },
    contactSection: {
      title: 'Avez-vous des questions ? N\'hésitez pas à nous les transmettre.',
      subtitle: 'Remplis ce formulaire pour que nous puissions mieux comprendre tes besoins et t\'accompagner de façon personnalisée.',
      form: {
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Email',
        message: 'Message',
        submit: 'Envoyer'
      }
    },
    footer: {
      location: 'Ottawa / Gatineau, Canada',
      copyright: '© 2025 Glow & You. Tous droits réservés.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      testimonials: 'Testimonials'
    },
    hero: {
      title: 'Reveal Your Best Version',
      subtitle: 'Personalized guidance to reveal and harmonize your style, personality, and wardrobe',
      cta: 'Start My Journey'
    },
    aboutSection: {
      title: 'About Glow & You',
      text: 'Glow and You specializes in image consulting and offers personalized support aimed at revealing and harmonizing the style, personality, and wardrobe of each person. Through a gentle, respectful, and deeply authentic approach, Glow and You guides each client towards an image aligned with who they truly are. The goal: to reveal the best version of yourself, with complete confidence.'
    },
    servicesSection: {
      title: 'What We Offer',
      subtitle: 'Tailored services to reveal your authentic visual identity, enhance your presence, and make every outfit an expression of who you truly are.',
      services: [
        {
          id: 1,
          title: '1. Signature Style',
          subtitle: 'Understanding your style and image',
          description: 'Personalized guidance to better understand yourself and define a style that truly reflects you.',
          subServices: ['Style analysis', 'Body shape study', 'Color analysis'],
          image: 'https://images.unsplash.com/photo-1551232864-3f0890e580d9'
        },
        {
          id: 2,
          title: '2. Smart Wardrobe',
          subtitle: 'Optimize your wardrobe',
          description: 'Learn to use what you already have and build a coherent and effective wardrobe.',
          subServices: ['Wardrobe sorting', 'Capsule wardrobe', 'Wardrobe audit', 'Shopping advice'],
          image: 'https://images.unsplash.com/photo-1547822280-d923f07fffbd'
        },
        {
          id: 3,
          title: '3. Personalized Support',
          subtitle: 'Find the right pieces for you',
          description: 'Tailor-made support to create looks adapted to your style, life, and needs.',
          subServices: ['Personal shopping', 'Event looks', 'Complete makeover', 'Special bridal image consulting (dress selection)'],
          image: 'https://images.unsplash.com/photo-1769345330795-322d300e386c'
        },
        {
          id: 4,
          title: '4. Workshops & Training',
          subtitle: 'Become autonomous in your style',
          description: 'Workshops to teach you how to understand your image and make the right choices yourself.',
          subServices: ['Individual workshop', 'Group workshop'],
          image: 'https://images.unsplash.com/photo-1761250246894-ee2314939662'
        }
      ]
    },
    forWhomSection: {
      title: 'For Whom?',
      subtitle: 'This service is for you if:',
      points: [
        'You want to feel more confident in your image',
        'You don\'t know how to dress according to your body shape',
        'You want to stop buying clothes you never wear',
        'You want a clear, simple, and aligned style'
      ]
    },
    bookingSection: {
      title: 'How to Book?',
      description: 'To offer a personalized, coherent service perfectly adapted to each client, Glow & You operates according to a simple and structured process, in three steps.',
      steps: [
        {
          number: '1',
          title: 'Fill out the form',
          description: 'Complete our pre-consultation form to let us know your needs'
        },
        {
          number: '2',
          title: 'Analysis by Glow & You',
          description: 'Our team analyzes your request and identifies the services suited to your profile'
        },
        {
          number: '3',
          title: 'Booking link sent',
          description: 'You receive a personalized link to book your consultation'
        }
      ],
      cta: 'Ready to reveal your best version?',
      ctaSubtitle: 'Fill out the form to start your personalized journey'
    },
    contactSection: {
      title: 'Do you have questions? Feel free to reach out.',
      subtitle: 'Fill out this form so we can better understand your needs and support you in a personalized way.',
      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        message: 'Message',
        submit: 'Send'
      }
    },
    footer: {
      location: 'Ottawa / Gatineau, Canada',
      copyright: '© 2025 Glow & You. All rights reserved.'
    }
  }
};

export const companyInfo = {
  name: 'Glow & You',
  email: 'Contact@glowyou.org',
  phone: '(343) 262-8604',
  location: 'Ottawa / Gatineau, Canada',
  instagram: '@glowandyou.consultation',
  instagramUrl: 'https://instagram.com/glowandyou.consultation',
  formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSefcvRv6S_cl3LlPdavRC0cyLvA19LpL4lZfvfRJzhW-bP6Pg/viewform?usp=publish-editor'
};

export const heroImage = '/hero.jpg';
